<section class="bbva-bnpl" [class.large-content]="!!(isLargeContent$ | async)?.isLargeContent">
  <div class="wrapper">
    <div class="bbva-bnpl__content">
      <div *ngIf="isLargeScreen" class="bbva-bnpl__content__background">
        <layout-navbar
          [currentFlow]="currentFlow$ | async"
          [currentRoute]="currentRoute$ | async"
          (clickMenu)="onReceiveClickEvent($event)"
        ></layout-navbar>
        <layout-footer-base [currentRoute]="currentRoute$ | async"></layout-footer-base>
      </div>
      <div class="bbva-bnpl__content__portal {{ currentFlow$ | async }}">
        <div *ngIf="!isLargeScreen" class="bbva-bnpl__content__portal__logo">
          <layout-navbar
            [currentFlow]="currentFlow$ | async"
            [currentRoute]="currentRoute$ | async"
            (clickMenu)="onReceiveClickEvent($event)"
          ></layout-navbar>
          <layout-toggle-menu-mobile
            [clickMenu]="openMenu$ | async"
            (closeMenu)="onCloseMenu($event)"
          ></layout-toggle-menu-mobile>
        </div>
        <div class="bbva-bnpl__content__portal__container">
          <div class="box {{ currentFlow$ | async }}">
            <div class="go-back">
              <layout-go-back
                [step]="step$ | async"
                [status]="(auth10tix$ | async)?.status"
                [canRetry]="(auth10tix$ | async)?.canRetry"
                [currentRoute]="currentRoute$ | async"
                [currentFlow]="currentFlow$ | async"
                (goBackEvent)="onGoBack($event)"
              ></layout-go-back>
            </div>
            <router-outlet></router-outlet>
          </div>
        </div>
        <layout-footer-base
          *ngIf="!isLargeScreen"
          [currentRoute]="currentRoute$ | async"
        ></layout-footer-base>
      </div>
    </div>
  </div>
</section>
<layout-modal></layout-modal>
